import { render, staticRenderFns } from "./Ecocup.vue?vue&type=template&id=8108e68c"
import script from "./Ecocup.vue?vue&type=script&lang=js"
export * from "./Ecocup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports